<template>
  <div class="row main-content">
    <div class="col">
      <h1 class="page-title font-custom text-uppercase mt-3">
        {{ $t('title.authorization.list') }}
      </h1>

      <div class="card rounded-0 mb-4">
        <form class="card-body">
          <div class="row mb-2">
            <!-- Distributor -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.authorization.distributor') }}
              </label>
              <select
                v-model="criterias.selectedIdDistributeur"
                :disabled="isDistributorLocked"
                :class="status(v$.criterias.selectedIdDistributeur)"
                name="distributor"
                class="form-control rounded-0 form-select"
                :data-placeholder="$t('label.authorization.distributor')"
              >
                <option
                  value
                  selected
                  disabled
                  hidden
                >
                  {{ $t('label.authorization.distributor') }}
                </option>
                <option
                  v-for="distributor in distributors"
                  :key="distributor.id"
                  :value="distributor"
                >
                  {{ distributor }}
                </option>
              </select>
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="v$.criterias.selectedIdDistributeur.oneRequired.$invalid">{{ $t('error.AUTHORIZATION_MISSING_MANDATORY_CRITERIA') }}</span>
              </p>
            </div>

            <!-- Holder Number -->
            <!--<div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.authorization.holderNumber') }}
              </label>
              <input
                v-model="criterias.selectedNumCard"
                :class="status(v$.criterias.selectedNumCard)"
                type="text"
                class="form-control rounded-0"
                :placeholder="$t('label.authorization.holderNumber')">
              <p
                v-if="validationError"
                class="error">
                <span v-if="v$.criterias.selectedNumCard.oneRequired">{{ $t('error.AUTHORIZATION_MISSING_MANDATORY_CRITERIA') }}</span>
                <span v-else-if="v$.criterias.selectedNumCard.$invalid">{{ $t('error.AUTHORIZATION_CARD_NUMBER_FORMAT') }}</span>
              </p>
            </div>-->

            <!-- Card ID -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.authorization.cardId') }}
              </label>
              <input
                v-model="criterias.selectedCardId"
                :class="status(v$.criterias.selectedCardId)"
                type="text"
                class="form-control rounded-0"
                :placeholder="$t('label.authorization.cardId')"
              >
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="v$.criterias.selectedCardId.oneRequired.$invalid">{{ $t('error.AUTHORIZATION_MISSING_MANDATORY_CRITERIA') }}</span>
                <span v-else-if="v$.criterias.selectedCardId.$invalid">{{ $t('error.AUTHORIZATION_CARD_ID_FORMAT') }}</span>
              </p>
            </div>

            <!-- Authorization Number -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.authorization.authorizationNumber') }}
              </label>
              <input
                v-model="criterias.selectedNumAut"
                :class="status(v$.criterias.selectedNumAut)"
                type="text"
                class="form-control rounded-0"
                :placeholder="$t('label.authorization.authorizationNumber')"
              >
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="v$.criterias.selectedNumAut.$invalid">{{ $t('error.AUTHORIZATION_AUTHORIZATION_NUMBER_FORMAT') }}</span>
              </p>
            </div>

            <!-- Merchant ID -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.authorization.merchantId') }}
              </label>
              <input
                v-model="criterias.selectedIdMarchand"
                :class="status(v$.criterias.selectedIdMarchand)"
                type="text"
                class="form-control rounded-0"
                :placeholder="$t('label.authorization.merchantId')"
              >
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="v$.criterias.selectedIdMarchand.$invalid">{{ $t('error.AUTHORIZATION_MERCHANT_ID_FORMAT') }}</span>
              </p>
            </div>
          </div>

          <div class="row mb-2">
            <!-- Start Date -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.authorization.startDate') }}
              </label>
              <span
                :title="$t('label.authorization.dateType')"
                data-bs-toggle="tooltip"
                data-bs-placement="left"
                class="label label-default ms-2"
              >
                <i class="fa fa-question-circle fa-xs" />
              </span>
              <input
                v-model="criterias.selectedStartDate"
                :class="status(v$.criterias.selectedStartDate)"
                type="date"
                class="form-control rounded-0"
                placeholder="yyyy-MM-dd"
              >
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="v$.criterias.selectedStartDate.required.$invalid">{{ $t('error.AUTHORIZATION_MANDATORY_CRITERIA') }}</span>
                <span v-else-if="v$.criterias.selectedStartDate.rangeMax.$invalid">{{ $t('error.AUTHORIZATION_MAX_DATE_RANGE', { range: dateRange }) }}</span>
              </p>
            </div>

            <!-- Start Time -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.authorization.startTime') }}
              </label>
              <input
                v-model="criterias.selectedStartTime"
                :class="status(v$.criterias.selectedStartTime)"
                type="time"
                step="1"
                class="form-control rounded-0"
                placeholder="HH:mm:ss"
              >
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="v$.criterias.selectedStartTime.$invalid">{{ $t('error.AUTHORIZATION_MANDATORY_CRITERIA') }}</span>
              </p>
            </div>

            <!-- End Date -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.authorization.endDate') }}
              </label>
              <span
                :title="$t('label.authorization.dateType')"
                data-bs-toggle="tooltip"
                data-bs-placement="left"
                class="label label-default ms-2"
              >
                <i class="fa fa-question-circle fa-xs" />
              </span>
              <input
                v-model="criterias.selectedEndDate"
                :class="status(v$.criterias.selectedEndDate)"
                type="date"
                class="form-control rounded-0"
                placeholder="yyyy-MM-dd"
              >
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="v$.criterias.selectedEndDate.required.$invalid">{{ $t('error.AUTHORIZATION_MANDATORY_CRITERIA') }}</span>
                <span v-else-if="v$.criterias.selectedEndDate.rangeMax.$invalid">{{ $t('error.AUTHORIZATION_MAX_DATE_RANGE', { range: dateRange }) }}</span>
              </p>
            </div>

            <!-- End Time -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.authorization.endTime') }}
              </label>
              <input
                v-model="criterias.selectedEndTime"
                :class="status(v$.criterias.selectedEndTime)"
                type="time"
                step="1"
                class="form-control rounded-0"
                placeholder="HH:mm:ss"
              >
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="v$.criterias.selectedEndTime.$invalid">{{ $t('error.AUTHORIZATION_MANDATORY_CRITERIA') }}</span>
              </p>
            </div>
          </div>

          <div class="row mb-2">
            <!-- Transaction Type -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.authorization.transactionType') }}
              </label>
              <select
                v-model="criterias.selectedTypeTransaction"
                name="typeTransaction"
                class="form-control rounded-0 form-select"
                :data-placeholder="$t('label.authorization.transactionType')"
              >
                <option
                  value
                  selected
                  disabled
                  hidden
                >
                  {{ $t('label.authorization.transactionType') }}
                </option>
                <option
                  v-for="type in transactionTypes"
                  :key="type.id"
                  :value="type.value"
                >
                  {{ type.text }}
                </option>
              </select>
            </div>

            <!-- Response Code -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.authorization.responseCode') }}
              </label>
              <multiselect
                v-model="criterias.selectedCodeRetour"
                :options="responseCodes"
                :searchable="false"
                :close-on-select="true"
                :multiple="true"
                :show-labels="false"
                class="rounded-0"
                :placeholder="$t('label.authorization.responseCode')"
              />
            </div>

            <!-- Amount -->
            <div class="col-12 col-sm-6 col-xl-3">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.authorization.amount') }}
              </label>
              <span
                :title="$t('label.authorization.amountFormat')"
                data-bs-toggle="tooltip"
                data-bs-placement="left"
                class="label label-default ms-2"
              >
                <i class="fa fa-question-circle fa-xs" />
              </span>
              <input
                v-model="criterias.selectedAmount"
                :class="status(v$.criterias.selectedAmount)"
                type="text"
                class="form-control rounded-0"
                :placeholder="$t('label.authorization.amount')"
              >
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="v$.criterias.selectedAmount.$invalid">{{ $t('error.AUTHORIZATION_AMOUNT_FORMAT') }}</span>
              </p>
            </div>
          </div>

          <div class="row mb-2">
            <!-- Submit -->
            <div class="col justify-content-end text-end criteria-button">
              <button
                type="button"
                class="btn btn-default btn-reset rounded-pill font-custom me-2"
                @click="reset()"
              >
                {{ $t('button.reset') }}
              </button>
              <button
                class="btn btn-primary btn-submit rounded-pill font-custom text-uppercase font-inverted"
                type="button"
                @click="search()"
              >
                <i class="fa fa-search me-1" />
                {{ $t('button.search') }}
              </button>
            </div>
          </div>
        </form>
      </div>

      <div v-if="$store.state.authorizations.authorizations.length">
        <div class="card card-body bg-light mb-4">
          <button
            type="button"
            class="btn btn-primary rounded-pill font-custom font-inverted btn-export"
            @click="downloadCSV()"
          >
            <i class="far fa-file-excel me-1" />
            {{ $t('button.export') }}
          </button>
        </div>

        <div class="table-responsive">
          <table class="table table-hover table-sm table-striped border">
            <thead>
              <tr>
                <th>{{ $t('label.authorization.distributor') }}</th>
                <th>{{ $t('label.authorization.holderNumber') }}</th>
                <th>{{ $t('label.authorization.transactionType') }}</th>
                <th>{{ $t('label.authorization.authorizationNumber') }}</th>
                <th>{{ $t('label.authorization.authorizationDate') }}</th>
                <th>{{ $t('label.authorization.amount') }}</th>
                <th>{{ $t('label.authorization.responseCode') }}</th>
                <th>{{ $t('label.authorization.responseCodeDetailed') }}</th>
                <th>{{ $t('label.authorization.acceptanceChannel') }}</th>
                <th>{{ $t('label.actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="authorization in displayedAuthorizations"
                :key="authorization.id"
                class="mb-3"
              >
                <td>{{ authorization.referenceDistributeur }}</td>
                <td>{{ authorization.numCarte }}</td>
                <td>{{ authorization.typeTransaction }}</td>
                <td>{{ authorization.numAut }}</td>
                <td>{{ $filters.date(authorization.dateTransaction) }}</td>
                <td>{{ $filters.currency(authorization.amount, authorization.currencyCode) }}</td>
                <td>
                  <span
                    :title="getResponseCodeInfo(authorization.codeRetour)"
                    data-bs-toggle="tooltip"
                    data-bs-placement="left"
                    class="label label-default"
                  >
                    {{ authorization.codeRetour }}
                    <i class="fa fa-question-circle fa-xs" />
                  </span>
                </td>
                <td>{{ authorization.codeRaisonDetaillee }}</td>
                <td>{{ $filters.uppercase(authorization.canalAcceptationValue) }}</td>
                <td>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary border-secondary rounded-pill font-custom"
                    @click="showDetails(authorization)"
                  >
                    {{ $t('button.detail') }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <Pager
          :posts="$store.state.authorizations.authorizations"
          @page-update="displayedAuthorizations = $event;"
        />
      </div>

      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="center-block"
        >
      </div>

      <div
        v-else-if="error"
        class="alert alert-warning text-center border-0 shadow-sm rounded-0"
      >
        {{ $t('error.'+`${responseErr}`) }}
      </div>
    </div>
  </div>
</template>

<script src="./AuthorizationList.js"></script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>

<style src="./AuthorizationList.scss" scoped lang="scss"></style>
